<lib-navbar
  *ngIf="showNavbar"
  class="navbar-login-component"
  (navbarHeight)="setContainerMarginTop($event)"
></lib-navbar>
<div class="login-gung-theme" [ngStyle]="containerStyles">
  <div [ngSwitch]="loginType">
    <tylo-fashion-login *ngSwitchCase="'FashionLogin'"></tylo-fashion-login>
    <lib-login *ngSwitchDefault></lib-login>
  </div>
</div>
<footer class="d-flex justify-content-center align-items-center">
  <a href="https://www.gung.se">www.gung.se</a>
</footer>
